import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-12 md:py-16 px-4 bg-slate-900" data-id="element-320">
      <div className="max-w-3xl mx-auto" data-id="element-321">
        <FadeIn data-id="element-322">
          <h2 className="text-3xl md:text-5xl font-serif italic text-amber-500 text-center mb-8 font-bold leading-tight" data-id="element-323">
            ¿Cuántos sábados más vas a llegar a la cima solo?
          </h2>
        </FadeIn>

        <div className="space-y-5 text-lg md:text-xl text-slate-300 leading-relaxed font-light" data-id="element-324">
          <FadeIn delay={0.1} data-id="element-325">
            <p data-id="element-326">
              Entrenás. Salís. Le ponés. Pero en la subida calculás de cabeza,
              empujás y rezás.
            </p>
          </FadeIn>

          <div className="py-5 pl-6 border-l-2 border-amber-500/50" data-id="element-327">
            <ul className="space-y-3" data-id="element-328">
              {['Piernas que se vacían en el mismo punto', 'Subidas que te destruyen aunque entrenes', 'Semanas sin saber si mejorás', 'Siempre sos el que espera'].map((item, i) => <FadeIn key={i} delay={0.2 + i * 0.1} direction="left" data-id="element-329">
                  <li className="flex items-start gap-3" data-id="element-330">
                    <span className="text-amber-500 mt-1 font-bold" data-id="element-331">→</span>
                    <span className="text-slate-300" data-id="element-332">{item}</span>
                  </li>
                </FadeIn>)}
            </ul>
          </div>

          <FadeIn delay={0.7} data-id="element-333">
            <div className="mt-6 bg-slate-950 border border-amber-500/30 rounded-2xl p-6 md:p-8 text-center shadow-lg" data-id="element-334">
              <p className="text-2xl md:text-3xl text-white font-bold" data-id="element-335">
                ¿Y si este fuera el último?
              </p>
              <p className="text-base md:text-lg text-slate-400 mt-2" data-id="element-336">
                No es falta de condición.{' '}
                <span className="text-amber-500 font-bold" data-id="element-337">
                  Es falta de un sistema.
                </span>
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}